var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricBoilerBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340,40c-55.2,0-100,44.8-100,100v60h-40c-22.1,0-40,17.9-40,40v40c0,22.1,17.9,40,40,40h40v520c0,55.2,44.8,100,100,100 h40v50c0,16.6,13.4,30,30,30s30-13.4,30-30v-50h200v50c0,16.6,13.4,30,30,30s30-13.4,30-30v-50h40c55.2,0,100-44.8,100-100V320h40 c22.1,0,40-17.9,40-40v-40c0-22.1-17.9-40-40-40h-40v-60c0-55.2-44.8-100-100-100H340z M340,120h400c11,0,20,9,20,20v60H320v-60 C320,129,329,120,340,120z M320,320h440v520c0,11-9,20-20,20H340c-11,0-20-9-20-20V320z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 580,
    r: 160,
    fill: "none",
    stroke: "black",
    strokeWidth: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,580) scale(0.65) translate(-528,-690)",
    d: "M428.1,690c-10,0-15-5-20-15c-5-10-5-15,0-25l125-180c5-5,10-5,15-5c5,0,10,5,10,10v110h75c10,0,15,5,20,15 c5,10,5,15,0,25l-125,180c-5,5-10,5-15,5s-10-5-10-10V690H428.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricBoilerBlack);
export default __webpack_public_path__ + "static/media/electric-boiler-black.1baeacb759d1c90106636a374f0a02d5.svg";
export { ForwardRef as ReactComponent };